import useIsMediaLessThan from "./useIsMediaLessThan.ts";

export function useIsFullScreenDialog() {
  return useIsMediaLessThan(501);
}
